export default function PrivacyPage() {
  return (
    <div>
      <section className="px-6 md:px-8 mt-12 space-y-6 mb-12">
        <h4 className="text-3xl">Terms of Use Degaan</h4>
        <div>
          <p>
            PLEASE READ THE TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING
            THIS SITE. This site is free to use by our visitors. And by using
            this site, you the user are agreeing to comply with and be bound by
            the following terms of use. After reviewing the following terms and
            conditions thoroughly, if you do not agree to the terms and
            conditions, please do not use this site.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Acceptance of Agreement:</strong>
          </h6>
          <p>
            You agree to the terms and conditions outlined in this Terms and
            Conditions of use Agreement (Agreement) with respect to our site
            (the Site). This Agreement constitutes the entire and only agreement
            between us and you, and supersedes all prior or contemporaneous
            agreements, representations, warranties and understandings with
            respect to the Site, the content, or services provided by or listed
            on the Site, and the subject matter of this Agreement. This
            Agreement may be amended by us at any time and at any frequency
            without specific notice to you. The latest Agreement will be posted
            on the Site, and you should review this Agreement prior to using the
            Site.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Copyright:</strong>
          </h6>
          <p>
            The content, organization, graphics, design, and other matters
            related to the Site are protected under applicable copyrights and
            other proprietary laws, including but not limited to intellectual
            property laws. The copying, reproduction, use, modification or
            publication by you of any such matters or any part of the Site is
            strictly prohibited, without our express prior written permission.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Deleting and Modification:</strong>
          </h6>
          <p>
            We reserve the right in our sole discretion, without any obligation
            and without any notice requirement to you, to edit or delete any
            documents, information or other content appearing on the Site,
            including this Agreement. Indemnification. You agree to indemnify,
            defend and hold us, our officers, our share holders, our partners,
            attorneys and employees harmless from any and all liability, loss,
            damages, claim and expense, including reasonable attorney&apos;s
            fees, related to your violation of this Agreement or use of the
            Site.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Disclaimer:</strong>
          </h6>
          <p>
            THE CONTENT, SERVICES FROM OR LISTED THROUGH THE SITE ARE PROVIDED
            &quot;AS-IS,&quot; &quot;AS AVAILABLE,&quot; AND ALL WARRANTIES,
            EXPRESS OR IMPLIED, ARE DISCLAIMED, INCLUDING BUT NOT LIMITED TO THE
            DISCLAIMER OF ANY IMPLIED WARRANTIES OF TITLE, NON-INFRINGEMENT,
            MERCHANTABILITY, QUALITY AND FITNESS FOR A PARTICULAR PURPOSE, WITH
            RESPECT TO THIS SITE AND ANY WEBSITE WITH WHICH IT IS LINKED. THE
            INFORMATION AND SERVICES MAY CONTAIN BUGS, ERRORS, PROBLEMS OR OTHER
            LIMITATIONS. WE HAVE NO LIABILITY WHATSOEVER FOR YOUR USE OF ANY
            INFORMATION OR SERVICE. IN PARTICULAR, BUT NOT AS A LIMITATION, WE
            ARE NOT LIABLE FOR ANY INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES
            (INCLUDING DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, LOSS OF
            MONEY, LITIGATION, OR THE LIKE), WHETHER BASED ON BREACH OF
            CONTRACT, BREACH OF WARRANTY, NEGLIGENCE, PRODUCT LIABILITY OR
            OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE
            NEGATION OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE
            BASIS OF THE BARGAIN BETWEEN US AND YOU THE USER. THIS SITE AND THE
            INFORMATION WOULD NOT BE PROVIDED WITHOUT SUCH LIMITATIONS. NO
            ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
            US THROUGH THE SITE SHALL CREATE ANY WARRANTY, REPRESENTATION OR
            GUARANTEE NOT EXPRESSLY STATED IN THIS AGREEMENT. THE INFORMATION
            AND ALL OTHER MATERIALS ON THE SITE ARE PROVIDED FOR GENERAL
            INFORMATION PURPOSES ONLY AND DO NOT CONSTITUTE PROFESSIONAL ADVICE.
            IT IS YOUR RESPONSIBILITY TO EVALUATE THE ACCURACY AND COMPLETENESS
            OF ALL INFORMATION AVAILABLE ON THIS SITE OR ANY WEBSITE WITH WHICH
            IT IS LINKED.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Limits:</strong>
          </h6>
          <p>
            All responsibility or liability for any damages caused by viruses
            contained within the electronic file containing the form or document
            is disclaimed. We will not be liable to you for any incidental,
            special or consequential damages of any kind that may result from
            use of or inability to use the site.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Third-Party Website:</strong>
          </h6>
          <p>
            All rules, terms and conditions, other policies (including privacy
            policies) and operating procedures of third-party linked websites
            will apply to you while on such websites. We are not responsible for
            the content, accuracy or opinions express in such Websites, and such
            Websites are not investigated, monitored or checked for accuracy or
            completeness by us. Inclusion of any linked Website on our Site does
            not imply approval or endorsement of the linked Website by us. This
            Site and the third-party linked websites are independent entities
            and neither party has authority to make any representations or
            commitments on behalf of the other. If you decide to leave our Site
            and access these third-party linked sites, you do so at your own
            risk.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Submissions:</strong>
          </h6>
          <p>
            All suggestions, ideas, notes, concepts, blog posts, and other
            information you may send to us (collectively,
            &quot;Submissions&quot;) shall be deemed and shall remain our sole
            property and shall not be subject to any obligation of confidence on
            our part. Without limiting the foregoing, we shall be deemed to own
            all known and hereafter existing rights of every kind and nature
            regarding the Submissions and shall be entitled to unrestricted use
            of the Submissions for any purpose, without compensation to the
            provider of the Submissions.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>Consent to be Contacted:</strong>
          </h6>
          <p>
            By clicking Register, you understand that real estate professionals
            may contact you by telephone, text or by electronic mail regarding
            your inquiry, and may involve automated means and
            pre-recorded/artificial voices. Registration is not a condition of
            buying any property, goods or services. Messages/data rates may
            apply. Consent can be withdrawn at any time by clicking the
            &quot;unsubscribe&quot; link contained in the email.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>General:</strong>
          </h6>
          <p>
            You agree that all actions or proceedings arising directly or
            indirectly out of this agreement, or your use of the site or any
            sample products obtained by you through such use, shall be litigated
            in the District Court of Utah. you are expressly submitting and
            consenting in advance to such jurisdiction in any action or
            proceeding in any of such court, and are waiving any claim that the
            District Court of Utah is an inconvenient forum or an improper forum
            based on lack of venue. This site is controlled by InsideRE, LLC. in
            the State of Utah, USA. As such, the laws of Utah will govern the
            terms and conditions contained in this Agreement and elsewhere
            throughout the Site, without giving effect to any principles of
            conflicts of laws.
          </p>
          <h6 className="mt-4 mb-4">
            <strong>GDPR Compliance:</strong>
          </h6>
          <p>
            This Site is intended solely for individuals residing outside of the
            territory of the European Union. By accessing and using this Site,
            you hereby agree and represent either (i) you are not a resident of
            the European Union, or (ii) if you are a resident of the European
            Union, that you hereby provide express consent to any personal
            information which may be collected from you by this Site, including,
            but not limited to, first name, last name, email address, phone
            number, physical address, IP address, and social media accounts and
            information. In no event shall any user cause this Site to collect
            personal information of any individual residing in the European
            Union without first obtaining the express consent of such
            individual.
          </p>
        </div>
      </section>

      {/* <section className="py-6 max-w-2xl mx-auto">
        <h4 className="text-3xl text-center font-semibold">Send Us a message</h4>
        <p className="text-center mt-3 mb-6 text-lg text-primary-600">
          Please complete the form below and an experienced member of our team
          will contact you for a free consultation.
        </p>
        <TOSContactForm />
      </section> */}
    </div>
  );
}
